export const CREATE_SESSION_FROM_EHR_APPOINTMENT_TOOL =
  'create_session_from_ehr_appointment';

const NAMED_EHR_TITLE = /^Create a session from your (.+) appointments$/;

/** Provider name from the server approval title, when the schedule item had one. */
export const ehrNameFromSessionCreateTitle = (
  title: string | undefined
): string | null => {
  const name = title?.match(NAMED_EHR_TITLE)?.[1]?.trim();
  return name ? name : null;
};
